import { render } from "./Fitments.vue?vue&type=template&id=587615a2&scoped=true"
import script from "./Fitments.vue?vue&type=script&lang=js"
export * from "./Fitments.vue?vue&type=script&lang=js"

import "./Fitments.vue?vue&type=style&index=0&id=587615a2&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587615a2"]])

export default __exports__